import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { TagInput } from '@/ui/components/controls/TagInput';
  import BigField from '@/_legacy/views/ChecklistBuilder/BigField.vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Tag } from '@/ui/components/Tag';
  import { CheckboxField } from '@/ui/components/form/CheckboxField';
  import { supportedFormLocalesOptions } from '@/ui/i18n/options';
  import { TranslationLanguage } from '@/entities/checklist';
  import { isManualFormTranslationsFeatureEnabled } from '@/ui/auth/auth';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Translations',
  props: {
    translationLanguages: {
      type: Array as () => TranslationLanguage[],
      required: true,
    },
    languages: {
      type: Array as () => string[],
      required: true,
    },
    containsError: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update-translation-languages'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const email = process.env.VUE_APP_CS_EMAIL;

  const options = computed(() => {
    const allOptions = supportedFormLocalesOptions();

    return allOptions.filter(opt => props.languages.includes(opt.value));
  });

  const selectedLocales = computed(() => {
    return props.translationLanguages.map(lang => lang.locale);
  });

  const translationLanguagesWithLabels = computed(() => {
    return props.translationLanguages.map(lang => ({
      locale: lang.locale,
      aiEnabled: lang.aiEnabled,
      label: getLabelForLocale(lang.locale),
    }));
  });

  const getLabelForLocale = (locale: string) => {
    const option = options.value.find(opt => opt.value === locale);

    return option ? option.label : locale;
  };

  const onLanguagesChanged = (langs: string[]) => {
    const existingLanguages = new Map(
      props.translationLanguages.map(lang => [lang.locale, lang.aiEnabled])
    );

    const updatedLanguages = langs.map(locale => ({
      locale,
      aiEnabled: existingLanguages.get(locale) ?? true,
    }));

    emit('update-translation-languages', updatedLanguages);
  };

  const onAiToggleChanged = (locale: string, enabled: boolean) => {
    const updatedLanguages = props.translationLanguages.map(lang =>
      lang.locale === locale ? { ...lang, aiEnabled: enabled } : lang);

    emit('update-translation-languages', updatedLanguages);
  };

  const selectAll = () => {
    onLanguagesChanged(props.languages.slice());
  };

  const deselectAll = () => {
    onLanguagesChanged([]);
  };

return { __sfc: true,props, emit, email, options, selectedLocales, translationLanguagesWithLabels, getLabelForLocale, onLanguagesChanged, onAiToggleChanged, selectAll, deselectAll, TagInput, BigField, Icon, Tag, CheckboxField, isManualFormTranslationsFeatureEnabled }
}

})